<script>
export default {
  name: "SupportView",
};
</script>

<template>
  <eg-b-container>
    <section>
      <eg-b-row>
        <eg-b-col>
          <h1 class="purple-text">{{ $t("support.lookingForHelp") }}</h1>
          <hr />
          <p class="mb-4">{{ $t("support.atEssayGrader") }}</p>
          <h4>{{ $t("support.contactUsViaChat") }}</h4>
          <p class="mb-4">{{ $t("support.chatSupportDescription") }}</p>
          <h4>{{ $t("support.faqTitle") }}</h4>
          <p class="mb-4">
            {{ $t("support.faqDescription") }}
            <a href="https://essaygrader.ai/faq" target="_blank">
              {{ $t("support.faqLink") }}
            </a>
            {{ $t("support.faqDescription2") }}
          </p>
          <h4>{{ $t("support.commonTopics") }}</h4>
          <ul class="mb-4">
            <li>{{ $t("support.topic1") }}</li>
            <li>{{ $t("support.topic2") }}</li>
            <li>{{ $t("support.topic3") }}</li>
          </ul>
          <h4>{{ $t("support.cantFindAnswer") }}</h4>
          <p>{{ $t("support.cantFindAnswerText") }}</p>
          <p class="mb-4">
            {{ $t("support.emailUsDetail") }}
            <a href="mailto:hello@essaygrader.ai?subject=Support">
              hello@essaygrader.ai
            </a>
          </p>
          <h4>{{ $t("support.appreciateFeedback") }}</h4>
          <p>
            {{ $t("support.appreciateFeedbackText") }}
            <a href="https://forms.gle/SZ7n3khm5iSRbMii8" target="_blank">
              {{ $t("support.shortForm") }} </a
            >.
          </p>
          <p>{{ $t("support.thankYouForBeingPart") }}</p>
        </eg-b-col>
      </eg-b-row>
    </section>
  </eg-b-container>
</template>
